import {Route, Routes, Navigate} from 'react-router-dom'
import {lazy} from 'react'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {useAuth} from '../modules/auth'
import {FC, Suspense} from 'react'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import CustomRoute from './Route'

const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'))
const Bookings = lazy(() => import('../pages/bookings/Bookings'))
const ViewBookings = lazy(() => import('../pages/bookings/ViewBookings'))
const AddBooking = lazy(() => import('../pages/bookings/AddBooking'))
const Events = lazy(() => import('../pages/events/Events'))
const AddEvent = lazy(() => import('../pages/events/AddEvent'))
const ViewEvent = lazy(() => import('../pages/events/ViewEvent'))
const Users = lazy(() => import('../pages/users/Users'))
const ViewUser = lazy(() => import('../pages/users/ViewUser'))
const Coaches = lazy(() => import('../pages/coaches/Coaches'))
const AddCoach = lazy(() => import('../pages/coaches/AddCoach'))
const ViewCoach = lazy(() => import('../pages/coaches/ViewCoach'))
const Locations = lazy(() => import('../pages/locations/Locations'))
const AddCourt = lazy(() => import('../pages/locations/AddCourt'))
const ViewLocation = lazy(() => import('../pages/locations/ViewLocation'))
const Vouchers = lazy(() => import('../pages/Vouchers/Voucher'))
const Staff = lazy(() => import('../pages/facility coordinator/Coordinator'))
const AddStaff = lazy(() => import('../pages/facility coordinator/AddCoordinator'))
const ViewCoordinator = lazy(() => import('../pages/facility coordinator/ViewCoordinator'))
const Membership = lazy(() => import('../pages/memberships/Memberships'))
const AddMembership = lazy(() => import('../pages/memberships/AddMembership'))
// const BookingsAnalytics = lazy(() => import('../pages/bookings/BookingAnalytics'))
const AppRoutes = () => {
  const {currentUser} = useAuth()

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route
          path='auth/*'
          element={
            currentUser?.role === 'super_admin' ? (
              <Navigate to='/dashboard' />
            ) : currentUser?.role === 'facility_coordinator' ? (
              <Navigate to='/staff' />
            ) : (
              <Navigate to='/coaches' />
            )
          }
        />
        <Route
          path='dashboard'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <Dashboard />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='bookings'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator']}>
              <SuspensedView>
                <Bookings />
              </SuspensedView>
            </CustomRoute>
          }
        />
        {/* <Route
          path='bookings-analytics'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator']}>
              <SuspensedView>
                <BookingsAnalytics />
              </SuspensedView>
            </CustomRoute>
          }
        /> */}
        <Route
          path='bookings/ViewBooking'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator', 'coach']}>
              <SuspensedView>
                <ViewBookings />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='bookings/addBooking'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator']}>
              <SuspensedView>
                <AddBooking />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='events'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator']}>
              <SuspensedView>
                <Events />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='events/addEvent'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator']}>
              <SuspensedView>
                <AddEvent />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='events/viewEvent'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator', 'coach']}>
              <SuspensedView>
                <ViewEvent />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='users'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <Users />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='users/viewUser'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator']}>
              <SuspensedView>
                <ViewUser />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='Staff'
          element={
            <CustomRoute allowedRoles={['super_admin', 'facility_coordinator']}>
              <SuspensedView>
                <Staff />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='Staff/addStaff'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <AddStaff />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='Staff/viewStaff'
          element={
            <SuspensedView>
              <ViewCoordinator />
            </SuspensedView>
          }
        />
        <Route
          path='memberships'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <Membership />
              </SuspensedView>
            </CustomRoute>
          }
        /> 
       <Route
          path='memberships/addMembership'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <AddMembership />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='locations'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <Locations />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='locations/addCourt'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <AddCourt />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='locations/viewLocation'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <ViewLocation />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='coaches'
          element={
            <CustomRoute allowedRoles={['super_admin', 'coach']}>
              <SuspensedView>
                <Coaches />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='coaches/addCoach'
          element={
            <CustomRoute allowedRoles={['super_admin', 'coach']}>
              <SuspensedView>
                <AddCoach />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='coaches/viewCoach'
          element={
            <CustomRoute allowedRoles={['super_admin', 'coach']}>
              <SuspensedView>
                <ViewCoach />
              </SuspensedView>
            </CustomRoute>
          }
        />
        <Route
          path='vouchers'
          element={
            <CustomRoute allowedRoles={['super_admin']}>
              <SuspensedView>
                <Vouchers />
              </SuspensedView>
            </CustomRoute>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')

  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 2,
    shadowBlur: 5,
  })

  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default AppRoutes
